
















































import { Profile } from '@/requests/mainApi';
import { Lead } from '@/requests/mainApi/models/Lead';
import { LeadAgreement } from '@/requests/mainApi/models/LeadAgreement';
import { storeModuleName } from '@/views/App/Profile/store';
import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapGetters, mapMutations, mapActions } from 'vuex';

interface Data {
  step: number;
  approvalData: {
    status: string;
    comment: string;
  };
}

interface Methods {
  outsideClick: (e: Event) => void;
  nextStep: () => void;
  prevStep: () => void;
  resetStep: () => void;
  submit: (e: any) => void;
  setCurrentLeadToApprove: (lead: Lead | null) => void;
  approveLead: (lead: LeadAgreement) => Promise<void>;
}

interface Computed {
  userData: Profile;
  className: string;
  currentLeadToApprove: Lead | null;
  isLessThanMinLength: boolean;
  isMoreThanMaxLength: boolean;
  commentIsInRange: boolean;
  isEmptyComment: boolean;
}

interface Props {
  close: () => void | null;
}

export default Vue.extend({
  name: 'ApproveModal',
  data() {
    return {
      step: 1,
      approvalData: {
        status: '1',
        comment: '',
      },
    };
  },
  props: {
    close: null,
  },
  methods: {
    outsideClick(e: MouseEvent) {
      if (!this.$refs.modal || (this.$refs.modal as HTMLElement).contains(e.target as HTMLElement)) {
        return;
      }
      this.close();
      this.resetStep();
      this.setCurrentLeadToApprove(null);
    },
    nextStep() {
      this.step++;
    },
    prevStep() {
      this.step--;
    },
    resetStep() {
      this.step = 1;
    },
    submit(e: any) {
      const body =
        this.approvalData.status === '1'
          ? {
              leadId: this.currentLeadToApprove.agreement.leadId,
              status: 'agreed',
            }
          : {
              leadId: this.currentLeadToApprove.agreement.leadId,
              status: 'not_agreed',
              comment: this.approvalData.comment,
            };
      this.approveLead(body as LeadAgreement).then(() => {
        this.nextStep();
      });
    },
    ...mapActions(storeModuleName, ['approveLead']),
    ...mapMutations(['setCurrentLeadToApprove']),
  },
  computed: {
    ...mapGetters(['userData', 'currentLeadToApprove']),
    className() {
      switch (this.step) {
        case 1:
          return 'modal-container--approve';
        case 2:
          return 'modal-container--confirm';
        case 3:
          return 'modal-container--answered';
        default:
          return 'modal-container--approve';
      }
    },
    isEmptyComment() {
      return this.approvalData.comment.length === 0;
    },
    isLessThanMinLength() {
      return this.approvalData.comment.length < 10;
    },
    isMoreThanMaxLength() {
      return this.approvalData.comment.length > 500;
    },
    commentIsInRange() {
      return this.approvalData.comment.length >= 10 && this.approvalData.comment.length <= 500;
    },

    textareaErrorMessage() {
      if (this.isEmptyComment) {
        return this.$t('app.profile.approveModal.required') as string;
      }
      if (this.isLessThanMinLength) {
        return this.$t('app.profile.approveModal.requiredMin') as string;
      }
      if (this.isMoreThanMaxLength) {
        return this.$t('app.profile.approveModal.requiredMax') as string;
      }
      return '';
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.outsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.outsideClick);
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
